export function isProjectSuspended(project) {
	return Boolean(project && ['PAUSED', 'CANCELED'].includes(project.lifecycleStatus));
}

export function canEditProject(project) {
	return Boolean(project && project.portalAccess === 'Full access' && !isProjectSuspended(project));
}

export function projectStatusKey(project) {
	if (isProjectSuspended(project)) return `projects.${project.lifecycleStatus.toLowerCase()}`;
	return project && project.active ? 'projects.filter.active' : 'projects.completed';
}
